import { useEffect, useState } from 'react'
import { AccessTime, Replay } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from 'shared/hooks'
import { useSessionCountdown } from 'shared/session'
import {
  Button,
  Divider,
  IconButton,
  Time,
  Wrapper,
} from './SessionCountdown.style'
import { formatSecondsLeft } from './SessionCountdown.utils'
import SessionExtensionDialog from './SessionExtensionDialog'

const SessionCountdown = () => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const secondsLeft = useSessionCountdown()
  const [isExtensionDialogOpen, setIsExtensionDialogOpen] = useState(false)

  // Closed once the session is extended, also in another tab
  useEffect(() => {
    if (secondsLeft === null) setIsExtensionDialogOpen(false)
  }, [secondsLeft])

  if (secondsLeft === null) return null

  const openExtensionDialog = () => setIsExtensionDialogOpen(true)

  return (
    <>
      <Wrapper>
        <Time>
          {!isMobile && <AccessTime />}
          {formatSecondsLeft(secondsLeft)}
        </Time>
        {isMobile ? (
          <IconButton
            aria-label={t('extendSession')}
            onClick={openExtensionDialog}
          >
            <Replay />
          </IconButton>
        ) : (
          <Button
            variant="contained"
            startIcon={<Replay />}
            fullWidth={false}
            disableElevation
            onClick={openExtensionDialog}
          >
            {t('extendSession')}
          </Button>
        )}
      </Wrapper>
      <Divider orientation="vertical" />
      {isExtensionDialogOpen && (
        <SessionExtensionDialog
          onClose={() => setIsExtensionDialogOpen(false)}
        />
      )}
    </>
  )
}

export default SessionCountdown
